module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-180x180.png";